import { InterfaceField, InterfaceFields } from './inputs-generator.model';
import { CustomFormData, FormFields } from '@orderform/widgets';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Bereitet die Feld-Liste für das Template auf.
 * @param fields
 * @param formValueChanges
 */
export function mapFieldListToFormStructure(
  fields: FormFields.Field[],
  formValueChanges: Observable<CustomFormData>
): InterfaceFields[] {
  const fieldsStructure: InterfaceFields[] = [
    // each entry is a row
  ];

  const addRow = () => {
    const pushIndex = fieldsStructure.push({
      fields: [],
    });
    return fieldsStructure[pushIndex - 1];
  };

  let activeRow = addRow();

  fields
    /**
     * @Timo why we have added this filter?
     */
    // .filter((field) => field.type !== 'hidden')
    .forEach((field, fieldId) => {
      const pushData: InterfaceField = {
        index: fieldId,
        field: {
          ...field,
          label: field.placeholder || field.label,
          placeholder: '', // no placeholder by design //  decodeHtml(field.placeholder || ''),
        },
        show$: _dependOnFormValueChanges(field.depends_on, formValueChanges),
      };

      activeRow.fields.push(pushData);

      if (field.in_row_with_next) {
        // use last active Row
      } else {
        activeRow = addRow();
      }
    });
  return fieldsStructure;
}

function _dependOnFormValueChanges(
  depends_on: FormFields.DependsOn,
  formValueChanges: Observable<CustomFormData>
) {
  return formValueChanges.pipe(
    map((results: CustomFormData) => isFormFieldVisible(results, depends_on))
  );
}

/**
 * Check is current field are visible
 * @param formValues
 * @param depends_on
 * @private
 */
export function isFormFieldVisible(
  formValues: CustomFormData,
  depends_on: FormFields.DependsOn
): boolean {
  let result = true;

  // prevent empty values and error by js (cant find x of undefined or null)
  depends_on = depends_on || {};

  Object.keys(depends_on).forEach((postname) => {
    // if result true, continue check
    if (result) {
      const requiredValue = depends_on[postname];
      result = formValues[postname] === requiredValue;
    } else {
      return false;
    }
  });
  return result;
}
